export default {
  data() {
    return {
      mainWrapClass: {},
      videoWrapClass: {},
      videoCompClass: {},
    }
  },
  mounted() {
  },
  methods: {
    addLogicForCssFix () {
      console.log('Triggered in cssFix.js');
      if (Number(this.globalFairConfig.FC_MOBILE_FIRST)) {
        window.addEventListener("resize", this.checkSize);
        this.addDynamicClasses()
        this.checkSize();
      }
    },
    checkSize() {
      if (window.innerWidth > 1025) {
        this.addDynamicClasses();
      } else {
        this.floorWrapClass = {};
        this.videoWrapClass = {};
        this.videoCompClass = {};
      }
    },
    addDynamicClasses() {
      this.floorWrapClass = {
        height: "100vh !important",
        overflow: "hidden !important",
        padding: "2vh 12% 0% 12% !important",
      };
      this.videoWrapClass = {
        "border-radius": "8px !important",
        height: "96vh !important",
        overflow: "hidden !important",
        "align-items": "flex-start !important",
      };
      this.videoCompClass = {
        "margin-top": "-42% !important",
      };
    },
  }
}